<div class="notifications-container">
  <h1 class="page-title">Notifications</h1>
  <p class="page-description">
    Configure your notification channels and choose which events you want to be notified about.
  </p>

  <!-- Channels Section -->
  <section class="channels-section">
    <h2 class="section-title">Public broadcast channels</h2>

    <!-- Public channels -->
    <div class="public-block-row">
      <div class="channel-block public-box public-channels-box">
        <div class="public-box-layout">
          <div class="public-box-main">
            <div class="channel-box-header">
              <img src="/assets/bot_public.png" alt="" class="channel-box-icon-img" />
              <h3 class="channel-title">Public channels<br/><span class="channel-title-sub">Telegram, Discord, and X</span></h3>
            </div>
            <p class="channel-explanation">
              Follow public marketplace updates across all official channels.
            </p>
            <div class="public-channel-list" *ngIf="publicNotificationChannels.length > 0; else publicChannelsNotConfigured">
              <a
                *ngFor="let channel of publicNotificationChannels"
                [href]="channel.url"
                target="_blank"
                rel="noopener noreferrer"
                class="public-channel-item"
              >
                <div class="channel-box-icon public-channel-icon" [ngClass]="'public-channel-icon-' + channel.type" aria-hidden="true">
                  <ng-container [ngSwitch]="channel.type">
                    <svg *ngSwitchCase="'telegram'" viewBox="0 0 24 24" class="public-channel-icon-svg">
                      <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.322.023.466.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.064-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.209.258-1.91.177-.184 3.247-2.977 3.307-3.23a.248.248 0 0 0-.058-.215.28.28 0 0 0-.252-.025c-.107.024-1.794 1.14-5.06 3.347-.478.328-.913.488-1.302.48-.428-.01-1.252-.24-1.865-.44-.752-.245-1.349-.374-1.297-.79.027-.216.324-.437.892-.663 3.488-1.52 5.814-2.523 6.978-3.01 3.325-1.384 4.016-1.624 4.467-1.632z" />
                    </svg>
                    <svg *ngSwitchCase="'discord'" viewBox="0 0 24 24" class="public-channel-icon-svg">
                      <path d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.946 2.4189-2.1568 2.4189Z" />
                    </svg>
                    <svg *ngSwitchCase="'x'" viewBox="0 0 24 24" class="public-channel-icon-svg">
                      <path d="M14.234 10.162 22.977 0h-2.072l-7.591 8.824L7.251 0H.258l9.168 13.343L.258 24H2.33l8.016-9.318L16.749 24h6.993zm-2.837 3.299-.929-1.329L3.076 1.56h3.182l5.965 8.532.929 1.329 7.754 11.09h-3.182z" />
                    </svg>
                  </ng-container>
                </div>
                <div class="public-channel-content">
                  <h4 class="public-channel-title">{{ channel.title }}<span class="channel-title-sub"> {{ channel.subtitle }}</span></h4>
                  <p class="public-channel-description">{{ channel.description }}</p>
                  <span class="public-channel-url">{{ channel.url }}</span>
                </div>
              </a>
            </div>
            <ng-template #publicChannelsNotConfigured>
              <div class="telegram-not-configured">
                Public channels not configured
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>

    <!-- Private channels -->
    <h2 class="section-title">Personalized notification channels</h2>

    <div class="private-channels-grid">
      <!-- Email -->
      <div class="channel-block email-box">
        <div class="channel-box-header">
          <div class="channel-box-icon channel-box-icon-email" aria-hidden="true">
            <span style="transform: translateY(-0.3rem);">✉</span>
          </div>
          <h3 class="channel-title">Email<br/><span class="channel-title-sub">Personal notifications</span></h3>
        </div>
        <p class="channel-explanation">
          Enter your email address to receive notifications for the events you subscribe to below.
        </p>
        <div class="channel-content email-box-body">
          <div class="email-form" [class.is-loading]="loadingEmail">
            <div class="input-wrapper">
              <input
                type="email"
                class="shared-input email-input"
                [ngModel]="userEmail"
                (ngModelChange)="onEmailChange($event)"
                [placeholder]="loadingEmail ? 'Loading...' : 'your.email@example.com'"
                [disabled]="loadingEmail || !isConnected"
              />
              <button
                class="submit save-btn"
                (click)="confirmSaveEmail()"
                [class.disabled]="!isConnected || loadingEmail || !userEmail || !canSaveEmail">
                <span *ngIf="loadingEmail">{{ userEmail ? 'Saving...' : 'Loading...' }}</span>
                <span *ngIf="!loadingEmail">Save</span>
              </button>
            </div>
          </div>
          <p class="email-privacy-notice">
            Cryptopunks.eth.limo respects your privacy. We are committed to full compliance with the
            <a href="https://gdpr.eu/" target="_blank" rel="noopener noreferrer">GDPR</a>
            and the
            <a href="https://ec.europa.eu/info/law/law-topic/data-protection_en" target="_blank" rel="noopener noreferrer">EU's data protection regulations</a>.
            You may
            <a href="#" (click)="isConnected ? confirmUnsubscribeEmail($event) : $event.preventDefault()">unsubscribe</a>
            from notification emails at any time.
          </p>
        </div>
      </div>

      <!-- Personal notifications -->
      <div class="channel-block telegram-box">
        <div class="channel-box-header">
          <img src="/assets/bot_private.png" alt="" class="channel-box-icon-img" />
          <h3 class="channel-title">Telegram<br/><span class="channel-title-sub">Personal notifications</span></h3>
        </div>
        <p class="channel-explanation">
          Stay informed with personalized notifications tailored to your preferences. Get instant stash bid alerts—including confidential bids—for punks you own. Join by clicking the link or scanning the QR code below.
        </p>
        <div class="channel-content telegram-box-body">
          <ng-container *ngIf="telegramBotUrl">
            <a [href]="telegramBotUrl" target="_blank" rel="noopener noreferrer" class="telegram-link">
              {{ telegramBotUrl }}
            </a>
          </ng-container>
          <div *ngIf="!telegramBotUrl" class="telegram-not-configured">
            Personal Telegram bot not configured
          </div>
        </div>
        <div class="telegram-box-footer">
          <ng-container *ngIf="telegramBotUrl">
            <div class="telegram-qr">
              <qr-code [value]="telegramBotUrl" [size]="120" styleClass="telegram-qrcode"></qr-code>
            </div>
            <div class="telegram-link-form" *ngIf="!telegramLinked">
              <input
                type="text"
                class="shared-input telegram-code-input shared-input"
                [(ngModel)]="telegramLinkCode"
                placeholder="Enter code from bot"
                maxlength="6"
                [disabled]="loadingTelegramLink || !isConnected"
              />
              <button
                class="submit telegram-link-btn"
                (click)="confirmLinkTelegram()"
                [class.disabled]="!isConnected || loadingTelegramLink || !telegramLinkCode.trim()">
                <span *ngIf="loadingTelegramLink">Linking...</span>
                <span *ngIf="!loadingTelegramLink">Link</span>
              </button>
              <p class="telegram-link-disclaimer">
                Wallet login required (<a href="https://delegate.xyz" target="_blank" rel="noopener noreferrer">delegate.xyz</a> supported)
              </p>
            </div>
            <div class="telegram-linked" *ngIf="telegramLinked">
              <span>
                Telegram linked
                <span class="telegram-link-id" *ngIf="telegramLinkIdentifier">
                  (ID: {{ telegramLinkIdentifier }})
                </span>
              </span>
              <button
                class="unlink-btn"
                (click)="confirmUnlinkTelegram()"
                [disabled]="loadingTelegramUnlink || !isConnected">
                <span *ngIf="loadingTelegramUnlink">Unlinking...</span>
                <span *ngIf="!loadingTelegramUnlink">Unlink</span>
              </button>
            </div>
            <div class="telegram-link-error" *ngIf="telegramLinkError">
              {{ telegramLinkError }}
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </section>

  <section class="x-admin-section" *ngIf="xAdminVisible">
    <h3 class="section-title">X admin bots</h3>
    <p class="matrix-description">
      Connect one X account per collection via OAuth to post public notifications: sales, listings, bids, wrap/unwrap, and stash bids (with card attachments).
    </p>

    <div class="matrix-loading" *ngIf="xAdminLoading">Loading X account status...</div>
    <div class="x-admin-message" *ngIf="xAdminMessage">{{ xAdminMessage }}</div>
    <div class="x-admin-error" *ngIf="xAdminError">{{ xAdminError }}</div>

    <ng-container *ngIf="!xAdminLoading && currentXAdminRow as row">
      <div class="x-admin-card">
        <div class="x-admin-card-header">
          <span class="x-admin-card-title">{{ row.label }}</span>
          <span class="x-admin-card-status" [class.connected]="row.connected" [class.disconnected]="!row.connected">
            {{ row.connected ? 'Connected' : 'Disconnected' }}
          </span>
        </div>
        <div class="x-admin-card-body">
          <p class="x-admin-card-account" *ngIf="row.connected">@{{ row.username || 'unknown' }}</p>
          <p class="x-admin-card-account empty" *ngIf="!row.connected">No X account linked</p>
        </div>
        <div class="x-admin-card-actions">
          <button class="submit" (click)="connectX(row.collectionId)" [disabled]="row.connecting || row.disconnecting || row.testing">
            {{ row.connecting ? 'Connecting...' : 'Connect' }}
          </button>
          <button class="submit" (click)="disconnectX(row.collectionId)" [disabled]="!row.connected || row.connecting || row.disconnecting || row.testing">
            {{ row.disconnecting ? 'Disconnecting...' : 'Disconnect' }}
          </button>
          <button class="submit" (click)="sendXTestPost(row.collectionId)" [disabled]="!row.connected || row.connecting || row.disconnecting || row.testing">
            {{ row.testing ? 'Posting...' : 'Post test' }}
          </button>
        </div>
      </div>
    </ng-container>
  </section>

  <!-- Subscription Matrix -->
  <section class="matrix-section">
    <h3 class="section-title">
      Personal notification preferences
    </h3>
    <p class="matrix-description">
      All personal notification preferences are currently active by default. Additional customization options will be available soon.
    </p>

    <div class="min-amount-limit-row" *ngIf="isConnected && effectiveAddress">
      <button
        class="submit min-amount-limit-btn"
        (click)="openMinAmountLimitModal()">
        Set minimum amount limit for bid notifications
      </button>
    </div>

    <div *ngIf="loadingSubscriptions" class="matrix-loading">
      Loading preferences...
    </div>

    <div *ngIf="!loadingSubscriptions" class="subscription-matrix">
      <table class="matrix-table">
        <thead>
          <tr>
            <th class="type-col">Notification type</th>
            <th class="channel-col">Email</th>
            <th class="channel-col">Telegram</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of matrixRows">
            <td class="type-col">{{ row.label }}</td>
            <td class="channel-col">
              <div
                class="toggle-cell"
                [class.saving]="row.emailSaving"
                [class.disabled]="row.emailDisabled"
                (click)="!row.emailDisabled && !row.emailSaving && toggleSubscription(row.type, 'email')">
                <div class="toggle" [class.on]="row.emailEnabled">
                  <div></div>
                </div>
              </div>
            </td>
            <td class="channel-col">
              <div
                class="toggle-cell"
                [class.saving]="row.telegramSaving"
                [class.disabled]="row.telegramDisabled"
                (click)="!row.telegramDisabled && !row.telegramSaving && toggleSubscription(row.type, 'telegram')">
                <div class="toggle" [class.on]="row.telegramEnabled">
                  <div></div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>

  <app-bid-min-amount-limit-modal
    [isActive]="minAmountLimitModalOpen"
    [ownerAddress]="effectiveAddress"
    (closed)="closeMinAmountLimitModal()"
    (saved)="closeMinAmountLimitModal()">
  </app-bid-min-amount-limit-modal>
</div>
